import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/g-force-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/g-force-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/g-force-calculator",
      title: m.gf_meta_title(),
      description: m.gf_meta_description(),
      toolName: m.gf_tool_name(),
      faqs: [
        { q: m.gf_faq_q1(), a: m.gf_faq_a1() },
        { q: m.gf_faq_q2(), a: m.gf_faq_a2() },
        { q: m.gf_faq_q3(), a: m.gf_faq_a3() },
        { q: m.gf_faq_q4(), a: m.gf_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
